export default {"src":"/_next/static/media/solana.e3f6e3a5.svg","height":14,"width":14};